module.exports = __webpack_public_path__ + "static/media/lobby-18.5bdbdeae.jpg";